import React, { useCallback, useState } from "react";
import axios from "axios";

import Header from "./components/Header";
import Hero from "./components/Hero";
import HowItWorks from "./components/HowItWorks";
import RoutePlanner from "./components/RoutePlanner";
import Results from "./components/Results";
import Footer from "./components/Footer";
import solveRoute from "./utils/solveRoute";

const API_URL = "https://travel-ease-server.vercel.app/api/shortest-path";

function App() {
  const [result, setResult] = useState(null);
  const [isLoading, setLoading] = useState(false);

  const handleSubmit = useCallback(async (addresses) => {
    setLoading(true);
    document
      .getElementById("results")
      ?.scrollIntoView({ behavior: "smooth", block: "start" });

    // The deployed API only accepts requests from its own domain, so the local
    // solver is the expected path in development and for this proof of concept.
    const local = solveRoute(addresses);

    try {
      const { data } = await axios.post(
        API_URL,
        {
          origin: addresses[0],
          destination: addresses[addresses.length - 1],
          stops: addresses.slice(1, -1),
        },
        { timeout: 8000 }
      );

      if (Array.isArray(data?.shortestPath) && data.shortestPath.length) {
        setResult({
          ...solveRoute(data.shortestPath),
          ordered: data.shortestPath,
          source: "api",
        });
        return;
      }
      setResult({ ...local, source: "local" });
    } catch (error) {
      setResult({ ...local, source: "local" });
    } finally {
      setLoading(false);
    }
  }, []);

  return (
    <>
      <Header />
      <main>
        <Hero />
        <HowItWorks />
        <RoutePlanner onSubmit={handleSubmit} isLoading={isLoading} />
        <Results result={result} isLoading={isLoading} />
      </main>
      <Footer />
    </>
  );
}

export default App;
